import { createSlice } from '@reduxjs/toolkit';

const initialState: any = {
  selectedTags: [],
  selectedHomeTag: null,
};

export const selectedTagsSlice = createSlice({
  name: 'selectedTags',
  initialState,
  reducers: {
    setTag: (state, action) => {
      const { boardId, type, tagId } = action.payload;

      // Find the board in the array, or create a new one if it doesn't exist
      const boardIndex = state.selectedTags.findIndex((board: any) => board?.boardId === boardId);

      if (boardIndex !== -1) {
        if (type === 'card') {
          state.selectedTags[boardIndex].card = tagId === null ? null : tagId;
        } else if (type === 'page') {
          state.selectedTags[boardIndex].page = tagId === null ? null : tagId;
        }
      } else {
        state.selectedTags.push({
          boardId: boardId,
          card: type === 'card' ? tagId : null,
          page: type === 'page' ? tagId : null,
        });
      }
    },
    setHomeTag: (state, action) => {
      const { tagId } = action.payload;
      // Only update if the tag is actually changing
      if (state.selectedHomeTag !== tagId) {
        state.selectedHomeTag = tagId;
      }
    }
  },
});

export const { setTag, setHomeTag } = selectedTagsSlice.actions;

export default selectedTagsSlice.reducer;
